
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Package, RefreshCw, Search } from "lucide-react";
import OrderFilters from "./OrderFilters";

interface NoOrdersProps {
  hasFilters: boolean;
  onClearFilters: () => void;
  onRefresh: () => void;
  searchTerm: string;
  statusFilter: string;
  dateFilter: string;
  onSearchChange: (value: string) => void;
  onStatusChange: (value: string) => void;
  onDateChange: (value: string) => void;
}

const NoOrders = ({ 
  hasFilters, 
  onClearFilters, 
  onRefresh,
  searchTerm,
  statusFilter,
  dateFilter,
  onSearchChange,
  onStatusChange,
  onDateChange,
}: NoOrdersProps) => {
  return (
    <Card variant="glass" className="border-white/10">
      <CardHeader>
        <div className="flex items-center justify-between">
          <CardTitle className="flex items-center gap-2">
            <Package className="h-5 w-5" />
            Order History
          </CardTitle>
          <Button variant="outline" size="sm" onClick={onRefresh} className="bg-transparent hover:bg-white/10">
            <RefreshCw className="h-4 w-4" />
          </Button>
        </div>
      </CardHeader>
      <CardContent>
        <OrderFilters
          searchTerm={searchTerm}
          statusFilter={statusFilter}
          dateFilter={dateFilter}
          onSearchChange={onSearchChange}
          onStatusChange={onStatusChange}
          onDateChange={onDateChange}
        />
        {hasFilters ? (
          <div className="text-center py-16">
            <div className="inline-block p-4 bg-primary/10 rounded-full mb-4">
              <Search className="h-10 w-10 text-primary mx-auto" />
            </div>
            <h3 className="text-xl font-semibold text-card-foreground mb-2">No Orders Found</h3>
            <p className="text-muted-foreground mb-6">Try adjusting your search or filter to find what you're looking for.</p>
            <Button variant="outline" onClick={onClearFilters} className="bg-transparent hover:bg-white/10">
              Clear Filters
            </Button>
          </div>
        ) : (
          <div className="text-center py-16">
            <div className="inline-block p-4 bg-primary/10 rounded-full mb-4">
              <Package className="h-10 w-10 text-primary mx-auto" />
            </div>
            <h3 className="text-xl font-semibold text-card-foreground mb-2">No orders to show</h3>
            <p className="text-muted-foreground mb-6">Looks like you haven't placed any orders yet. Let's change that!</p>
            <Button onClick={() => window.location.href = '/products'}>
              Start Shopping
            </Button>
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default NoOrders;
